import {React, useState, useEffect, useRef, createContext} from 'react';
import {Route, Routes, Navigate } from 'react-router-dom';

import styles from './leagues.module.css'

import constants from '../../../constants.js';

import Dashboard from '../../../components/main/Dashboard/Dashboard.js'
import Standings from '../../../components/main/Standings/Standings.js'
import Players from '../../../components/main/Players/Players.js'
import Playoffs from '../../../components/main/Playoffs/Playoffs.js'
import Teams from '../../main/Teams/Teams.js'
import Lineups from '../../../components/main/Lineups/Lineups.js';
import Matchup from '../../../components/main/MatchupWizard/MatchupWizard.js';
import MessageDialog from '../../common/MessageDialog/MessageDialog.js';
import { useSidebarProvider } from '../../../providers/SidebarProvider.js';
import { useApiProvider } from '../../../providers/ApiProvider.js';

const Leagues = ({selectedLocation,
                  selectedDivision, setSelectedDivision,
                  selectedMenuItem, setSelectedMenuItem}) => {

  const { setIsSidebarShowing } = useSidebarProvider();
  const { isLoading } = useApiProvider();

  useEffect(() => {
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
  }, []);

  return (
    <div className={styles.Leagues}> 
      <Routes>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route 
          path="dashboard" 
          element={<Dashboard 
                    selectedMenuItem={selectedMenuItem} 
                    setSelectedMenuItem={setSelectedMenuItem} 
                    selectedLocation={selectedLocation} 
                    selectedDivision={selectedDivision}/>}
        />
        <Route 
          path="/standings" 
          element={<Standings 
                    selectedLocation={selectedLocation} 
                    selectedDivision={selectedDivision}
                    setSelectedMenuItem={setSelectedMenuItem}/>}/>
        <Route 
          path="/players" 
          element={<Players 
                    selectedLocation={selectedLocation} 
                    selectedDivision={selectedDivision}
                    setSelectedMenuItem={setSelectedMenuItem} />}/>
        <Route 
          path="/playoffs" 
          element={<Playoffs 
                    selectedLocation={selectedLocation} 
                    selectedDivision={selectedDivision}
                    setSelectedMenuItem={setSelectedMenuItem} />}/>
        <Route 
          path="/teams" 
          element={<Teams 
                    selectedLocation={selectedLocation} 
                    selectedDivision={selectedDivision}
                    setSelectedMenuItem={setSelectedMenuItem} />}/>
        <Route 
          path="/lineups" 
          element={<Lineups 
                    selectedLocation={selectedLocation} 
                    selectedDivision={selectedDivision}
                    setSelectedMenuItem={setSelectedMenuItem} />}/>
        <Route 
          path="/matchup" 
          element={<Matchup/>}/>
      </Routes>
    </div>
  );
}
export default Leagues;
